import classNames from 'classnames';

/* Components */
import { TextArea } from 'ht-styleguide';
import { WarningHintIcon } from '@components/UI/Messages';

/* Styles */
import styles from './prequestioncheckbox.module.scss';

/* Types */
import { Question } from 'types/sku.types';

type PreQuestionTextAreaProps = {
  question: Question;
  error?: string;
  value: string;
  onChange: BaseAnyFunction;
};

const PreQuestionTextArea = (props: PreQuestionTextAreaProps) => {
  const { question, value, onChange, error } = props;

  /* Styles */
  const hintIconStyles = classNames(styles.answerHintIcon, styles.answerHintIconInput);

  return (
    <div>
      <div className={styles.answer}>
        <TextArea label={question.textDirect} value={value} onChange={onChange} error={error} />
        <WarningHintIcon content={question.hint} hintIconStyles={hintIconStyles} />
      </div>
    </div>
  );
};

export default PreQuestionTextArea;
